export default __webpack_public_path__ + "static/media/Amex_logo_color.68351fbf.svg";